import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import { ContentToolsModule } from '../../../shell/content-tools/content-tools.module';
import { ListDisplayStudentModule } from '../list-display/list-display-student/list-display-student.module';
import { AttendanceListComponent } from './attendance-list.component';
import { AttendanceMadLibModule } from './attendance-mad-lib/attenance-mad-lib.module';
import { AttendanceService } from './attendance.service';

@NgModule({
  declarations: [AttendanceListComponent],
  imports: [
    AttendanceMadLibModule,
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    ListDisplayStudentModule,
    MatMenuModule,
    ContentToolsModule,
  ],
  exports: [AttendanceListComponent],
  providers: [FlagsFilterService, AttendanceService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AttendanceListModule {
  /** */
}
